/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type ClientRendererQueryVariables = {};
export type ClientRendererQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly isOrgAdmin: boolean | null;
            readonly organisation: {
                readonly name: string;
                readonly hasFms: boolean | null;
            } | null;
        } | null;
    } | null;
    readonly v2: {
        readonly viewer: {
            readonly user: {
                readonly profilePicture: {
                    readonly source: string;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type ClientRendererQuery = {
    readonly response: ClientRendererQueryResponse;
    readonly variables: ClientRendererQueryVariables;
};



/*
query ClientRendererQuery {
  viewer {
    user {
      isOrgAdmin
      organisation {
        name
        hasFms
        id
      }
      id
    }
    id
  }
  v2 {
    viewer {
      user {
        profilePicture(size: LARGE) {
          source
        }
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isOrgAdmin",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "hasFms",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "profilePicture",
        "storageKey": "profilePicture(size:\"LARGE\")",
        "args": [
            {
                "kind": "Literal",
                "name": "size",
                "value": "LARGE"
            }
        ],
        "concreteType": "ProfilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "source",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ClientRendererQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "organisation",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Organisation",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        (v2 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "v2",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "V2",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "viewer",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ViewerV2",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserV2",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "ClientRendererQuery",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "organisation",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Organisation",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        (v2 /*: any*/),
                                        (v4 /*: any*/)
                                    ]
                                },
                                (v4 /*: any*/)
                            ]
                        },
                        (v4 /*: any*/)
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "v2",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "V2",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "viewer",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ViewerV2",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserV2",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        (v4 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "ClientRendererQuery",
            "id": null,
            "text": "query ClientRendererQuery {\n  viewer {\n    user {\n      isOrgAdmin\n      organisation {\n        name\n        hasFms\n        id\n      }\n      id\n    }\n    id\n  }\n  v2 {\n    viewer {\n      user {\n        profilePicture(size: LARGE) {\n          source\n        }\n        id\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '3ebfd0aad07d943e4796c6f6b7e5fd11';
export default node;
